export default __webpack_public_path__ + "static/media/max logo.0f3462db.svg";